import {
	RefObject,
	useCallback,
	useEffect,
	useLayoutEffect,
	useRef
} from "react";

export const useIsMounted = (): () => boolean => {
	const isMounted: RefObject<boolean> = useRef<boolean>(false);

	useEffect(
		() => {
			isMounted.current = true;
		},
		[]
	);

	useLayoutEffect(
		() => {
			return () => {
				isMounted.current = false;
			};
		},
		[]
	);

	return useCallback(
		() => isMounted.current,
		[]
	);
};